import styled from "styled-components";
import {
	Avatar as AntAvatar,
	Input as AntInput,
	Button as AntButton,
	Form as AntForm,
} from "antd";
import { NoImageUser } from "@assets";

export const RootContainer = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;
	position: relative;
	margin: 0 16px;
	min-height: calc(100vh - 70px);
	gap: 16px;
	overflow: hidden;
`;

export const AvatarWrapper = styled.div`
	margin: 16px 0 0;
	border-radius: 50%;
`;

export const Avatar = styled(AntAvatar)`
	border-radius: 50% !important;
`;

export const ProfileInputContainer = styled.div`
	position: absolute;
	bottom: 0;
	right: 0px;
	border-radius: 0px 0px 12px 12px;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const InputLabel = styled.p`
	position: absolute;
	left: 24px;
	top: -8px;
	z-index: 30;
	margin: 0px;
	padding: 0px 4px;
	color: #535b5d;
	background-color: white;
	font-family: Plus Jakarta Sans;
	font-size: 12px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
`;

export const Input = styled(AntInput)`
	border-radius: 16px;
	border: none;
	height: 52px;
	border: 1px solid #CCC;

	font-size: 16px !important ;
	font-weight: 500;
	line-height: 22.5px;

	:focus, :hover {
		border: 1px solid #FB0 !important;
		box-shadow: none !important;
	}

	.ant-input {
		font-size: 17px !important;
	}

	.ant-input::placeholder {
		color: #686b6e;
		font-weight: 200;
		font-size: 18px;
	}

	&&& {
		padding-left: 24px;
	}
`;

export const PhoneNumberWrapper = styled.div`
	background-color: #161719;
	font-size: 18px;
	font-weight: 400;
	line-height: 22.5px;
	color: #424242;
	height: 54px;
	border-radius: 8px;
	display: flex;
	align-items: center;
	padding-left: 24px;
`;

export const FileInput = styled.input`
	display: none;
`;

export const SaveButton = styled(AntButton)`
	box-sizing: border-box !important ;
	width: calc(100%) !important;
	height: 52px;
	margin: 25px 15px 20px;
`;

export const NoImageIcon = styled.img.attrs({
	src: `${NoImageUser}`,
	alt: "no_img",
})`
	margin-top: 4px;
	width: 73px;
	height: 73px;
`;

export const Form = styled(AntForm)`
	width: 100%;
	height: 100%;
	position: relative !important;

	.ant-form-item {
		margin: 0 0 24px 0px;
	}

	.ant-form-item-label > label.ant-form-item-required::before {
		content: none;
	}

	.ant-form-item-label label {
		color: #1E1E1E;
		font-size: 16px;
		font-style: normal;
		font-weight: 400;
		line-height: 26px; /* 162.5% */
	}

	.ant-input-affix-wrapper-readonly {
		background-color: #F7F7F7 !important;
		cursor: not-allowed;
	}

	.ant-input-affix-wrapper-readonly > input{
		cursor: not-allowed;
		color: #979797;
	}

	.ant-form-item-explain {
		text-align: left; /* align warning text to the left */
		margin-left: 24px;
	}

`;

export const LevelBadge = styled.div`
	color: #FFF;
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: 20px; /* 200% */

	height: 26px;
	padding: 0 8px;
	border-radius: 16px;
	background: rgba(227, 148, 1, 0.50);

	display: flex;
	align-items: center;
	justify-content: center;
	gap: 5px;
`
